<template>
  <div class="md:mt-0 lg:mt-0 mt-6 shadow-xl bg-white rounded-b-lg">
    <a class="cursort-pointer" target="_blank" href="">
      <img
        src=""
        alt="image"
        class="rounded-t-lg h-52 w-full object-cover cursor-pointer"
      />
      <div class="p-4">
        <p
          class="text-black font-bold cursor-pointer fsize20-14px ellipsis-2 lh-28"
        >
          Title
        </p>
      </div>
      <!-- <p class="text-sm">
        {{ item.webinar }}<span class="text-primary pl-1 underline">here</span>
      </p> -->
    </a>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    category: {
      type: String,
      default: "blog",
    },
  },
  data() {
    return {
      hasError: false,
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
    };
  },
  computed: {
    image() {
      return this.item.image
        ? `${this.$imageURL}/${this.item.image}`
        : this.defaultImage;
    },
    url() {
      if (this.item.link.includes("http")) {
        return this.item.link;
      } else {
        return "https://" + this.item.link;
      }
    },
  },
};
</script>
